import { createContext, useContext, type ReactNode } from "react";
import type IHeaderInteractions from "./header-interactions.interface";

const HeaderInteractionsContext = createContext<IHeaderInteractions | null>(
    null,
);

export function HeaderInteractionsProvider({
    interactions,
    children,
}: {
    interactions: IHeaderInteractions;
    children: ReactNode;
}) {
    return (
        <HeaderInteractionsContext value={interactions}>
            {children}
        </HeaderInteractionsContext>
    );
}

export function useHeaderSignIn() {
    const interactions = useContext(HeaderInteractionsContext);
    return () => {
        if (!interactions)
            throw new Error(
                "HeaderInteractionsProvider is required for sign in",
            );
        interactions.onSignIn();
    };
}
